import { Contract } from "../types/contract";
import { OfferScopeOfWorkSelect } from "../../offer/components/offer-scope-of-work-select";
import {
  ContractScopeOfWorkAddDialog,
  ContractScopeOfWorkAddDialogConfig,
} from "./contract-scope-of-work-add-dialog";
import { ContractScopeOfWorkDeleteDialog } from "./contract-scope-of-work-delete-dialog";

/**
 * ContractScopeOfWorkToolbar selects, adds and deletes the scope of works
 * of the contract. selectedId is the selected one; onSelect receives the
 * one selected or added, and no id after a delete.
 */
export function ContractScopeOfWorkToolbar({
  contract,
  addDialogConfig,
  selectedId,
  onSelect,
  disabled,
}: {
  contract: Contract;
  addDialogConfig: ContractScopeOfWorkAddDialogConfig;
  selectedId: string | undefined;
  onSelect: (id?: string) => void;
  disabled: boolean;
}) {
  return (
    <div className="flex items-center gap-2">
      <div className="min-w-0 flex-1">
        <OfferScopeOfWorkSelect
          scopeOfWorks={contract.scopeOfWork}
          value={selectedId}
          onValueChange={onSelect}
        />
      </div>
      <ContractScopeOfWorkAddDialog
        contract={contract}
        config={addDialogConfig}
        onCreated={onSelect}
        disabled={disabled}
      />
      <ContractScopeOfWorkDeleteDialog
        contractId={contract.id}
        scopeOfWorkId={selectedId}
        onDeleted={() => onSelect(undefined)}
        disabled={disabled}
      />
    </div>
  );
}
